var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",class:_vm.mapSize ? _vm.mapSize : 'map-sm',staticStyle:{"width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }